import { Icon } from '@frontend/icons';

export const DesktopActiveCallBarTrail = ({ isOpen }: { isOpen?: boolean }) => {
  return <>{isOpen ? <Icon name='caret-up-small' /> : <Icon name='caret-down-small' />}</>;
};
